import { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { Download, Speed } from '@mui/icons-material';

const InstallPromptPopup = ({ open, onClose }) => {
  const [installPrompt, setInstallPrompt] = useState(null);

  useEffect(() => {
    console.log('InstallPromptPopup: Component mounted, open=', open);
    
    const handleBeforeInstallPrompt = (e) => {
      console.log('InstallPromptPopup: beforeinstallprompt event captured');
      e.preventDefault();
      setInstallPrompt(e);
    };

    // Listen for the beforeinstallprompt event
    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (installPrompt) {
      console.log('InstallPromptPopup: Triggering native install prompt');
      try {
        await installPrompt.prompt();
        const { outcome } = await installPrompt.userChoice;
        console.log(`InstallPromptPopup: User ${outcome} the install prompt`);
        
        if (outcome === 'accepted') {
          localStorage.setItem('installPromptShown', 'true');
        }
        
        setInstallPrompt(null);
        onClose();
      } catch (error) {
        console.error('InstallPromptPopup: Error during install:', error);
        // Fallback - show manual install instructions
        handleManualInstall();
      }
    } else {
      console.log('InstallPromptPopup: No native prompt available, showing manual instructions');
      handleManualInstall();
    }
  };

  const handleManualInstall = () => {
    // Detect browser and show appropriate instructions
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isAndroid = /Android/.test(navigator.userAgent);
    const isChrome = /Chrome/.test(navigator.userAgent);
    
    let instructions = '';
    if (isIOS) {
      instructions = 'Tap the Share button and select "Add to Home Screen"';
    } else if (isAndroid || isChrome) {
      instructions = 'Tap the menu (⋮) and select "Add to Home Screen" or "Install App"';
    } else {
      instructions = 'Look for "Add to Home Screen" or "Install" option in your browser menu';
    }
    
    alert(`To install this app:\n\n${instructions}`);
    onClose();
  };

  const handleNotNow = () => {
    console.log('InstallPromptPopup: User dismissed install prompt');
    localStorage.setItem('installPromptDismissed', 'true');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleNotNow}
      PaperProps={{
        sx: {
          width: { xs: '90%', sm: 400 },
          maxWidth: '100%',
          margin: 'auto',
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
        <Download sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />
        <Typography variant="h6">Install Our App</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 3, textAlign: 'center' }}>
          Get a better experience by installing our app on your device!
        </Typography>
        
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Speed sx={{ color: 'primary.main' }} />
            <Typography variant="body2">Faster loading and better performance</Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between', px: 3, pb: 3 }}>
        <Button onClick={handleNotNow} color="text">
          Not Now
        </Button>
        <Button
          onClick={handleInstallClick}
          variant="contained"
          color="primary"
          sx={{ minWidth: 120 }}
        >
          Install
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InstallPromptPopup;